import { useSectionState } from "components/Characters/components/hooks/useSectionState";
import { EMPTY_LIST } from "constants/defaults";
import { useAuth } from "contexts/AuthContext";
import { useSmartRef } from "hooks/useSmartRef";
import { findIndex } from "lodash";
import { useCallback } from "react";

export const useRecentlyUsedImages = () => {
  const { user, loading, authLoaded, updateUser } = useAuth();
  const updateUserRef = useSmartRef(updateUser);

  const updateUseSectionStateUser = useCallback(
    (id, updater) => {
      updateUserRef.current(updater, { shouldValidateAfterUpdate: true });
    },
    [updateUserRef]
  );
  const [
    recentlyUsedImages,
    setRecentlyUsedImages,
    { updating: updatingRecentlyUsedImages },
  ] = useSectionState({
    key: "recentlyUsedImages",
    id: user?.uid,
    originalState: user?.recentlyUsedImages || EMPTY_LIST,
    shouldDisableDirty: true,
    updateItem: updateUseSectionStateUser,
    delay: 0,
  });

  const addRecentlyUsedImage = (image) => {
    if (!user) {
      return;
    }

    setRecentlyUsedImages((prev) => [
      image,
      ...prev.slice(0, 24).filter((v) => v !== image),
    ]);
  };
  const removeRecentlyUsedImage = (image) => {
    if (!user) {
      return;
    }

    setRecentlyUsedImages((prev) => {
      const targetI = findIndex(prev, (img) => img === image);

      if (targetI === -1) {
        return prev;
      }

      const copy = [...prev];
      copy.splice(targetI, 1);

      return copy;
    });
  };

  return {
    recentlyUsedImages,
    setRecentlyUsedImages,
    addRecentlyUsedImage,
    removeRecentlyUsedImage,
    fetchingRecentlyUsedImages: loading || authLoaded || !user,
    updatingRecentlyUsedImages,
  };
};
